import React from 'react';
import { navigate } from 'gatsby';

import swal from 'sweetalert';
import { GraphQLClient, gql } from 'graphql-request';

import config from '../../utils/config';
import ContactForm from '../forms/ContactForm';

const client = new GraphQLClient(config.apiUrl, {
  timeout: 60000,
});

const contactUsMutation = gql`
  mutation contact($input: ContactInput) {
    contact(input: $input) {
      status
      message
    }
  }
`;

const ContactFormBlock = () => {
  const handleSubmit = async (formData) => {
    const variables = { input: formData };

    await client
      .request(contactUsMutation, variables)
      .then((data2) => {
        setTimeout(() => {
          if (data2) {
            navigate('/thank-you/');
          }
        }, 3000);
      })
      .catch((error) => {
        swal('Success!', error, 'success');
      });
  };

  return (
    <section className="section">
      <div className="container">
        <ContactForm onSubmit={(val) => handleSubmit(val)} />
      </div>
    </section>
  );
};

export default ContactFormBlock;
